import * as React from 'react';

import { cn } from '../../../../utils';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
	htmlFor: string;
	label?: string | React.ReactElement;
	className?: string;
	labelSrOnly?: boolean;
	required?: boolean;
}

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
	({ className, htmlFor, label, labelSrOnly, required }, ref) => {
		return (
			<label
				htmlFor={htmlFor}
				className={cn(
					'block text-body-md font-normal text-primaryTextDark',
					className,
					labelSrOnly ? 'sr-only' : ''
				)}
				ref={ref}
			>
				{label}
				{required && <span className='text-md text-error ml-1 leading-[14px]'>*</span>}
			</label>
		);
	}
);
